var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconPackageColour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 0H0v32h42V0z",
    fill: "#E8B961"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 0h-9v32h9V0z",
    fill: "#958566"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 6H16v7h13V6z",
    fill: "#F4F4F4"
  })));
}

export default SvgIconPackageColour;